import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { LanguageService } from '@mzic/mzic-services';

@Component({
  selector: 'mzic-footer',
  imports: [CommonModule, TranslocoModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  providers: [
    provideTranslocoScope({
      scope: 'investor-landing',
      alias: 'lang',
    }),
  ],
})
export class FooterComponent {
  @Input() appStoreUrl = 'https://apps.apple.com/br/app/mzic/id1670495038';
  @Input() playStoreUrl =
    'https://play.google.com/store/apps/details?id=io.mzic.app';

  languageService = inject(LanguageService);
  router = inject(Router);

  // Social media links
  socialLinks = {
    instagram: 'https://www.instagram.com/mzicbrasil/',
    youtube: 'https://youtube.com/@mzicapp',
    spotify: 'https://spotify.com/mzic',
    linkedin: 'https://www.linkedin.com/company/mzic/',
  };

  // Footer links
  footerLinks = {
    forArtists: 'https://artists.mzic.io/',
    termsOfUse: 'https://legal.mzic.io/pt-br/terms-of-use',
    privacyPolicy: 'https://legal.mzic.io/pt-br/privacy',
    faqLearnMore: 'https://mzic.io/faq',
  };

  // App badges images
  googlePlayDownload = 'assets/images/googleplay-download.svg';
  appStoreDownload = 'assets/images/appstore-download.svg';

  goToAboutMzic() {
    const lang = this.languageService.languageState();
    if (lang !== '') {
      this.router.navigate([`${lang}/about`]);
    } else {
      this.router.navigate(['/about']);
    }
  }

  goToContact() {
    const lang = this.languageService.languageState();
    if (lang !== '') {
      this.router.navigate([`${lang}/contact`]);
    } else {
      this.router.navigate(['/contact']);
    }
  }
}
